import { TableColumn } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { CheckmarkColumnComponent } from 'src/app/shared/components/listing-table/components/checkmark-column';
import { getUrlPathForDeviceTypeName } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.helpers';
import { MultiLineHighlightComponent } from '@portal/shared/components/listing-table/components/multi-line-highlight-column.component';
import {
  CustomizableColumnComponent,
  CustomizableColumnType,
  CustomizableTableColumn,
  CustomizableTableColumnValue
} from '@portal/shared/components/listing-table/components/customizable-column.component';
import { DeviceType } from 'src/app/pages/equipment/devices/components/devices.models';
import type { FieldOperationsListItem } from '../ui/field-operations.types';

export const createFieldOperationsColumns = (): (TableColumn | CustomizableTableColumn)[] => [
  {
    field: 'installationDateTime',
    sortable: true,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.OPERATION_DATE_TIME
  },
  {
    field: 'mtuDeviceLabel',
    link: {
      getLink: (dataItem): string => `devices/${getUrlPathForDeviceTypeName(DeviceType.MTU)}/${dataItem['deviceUID']}`
    },
    sortable: true,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.COMM_DEVICE_ID
  },
  {
    field: 'installationReason',
    sortable: true,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.REASON
  },
  {
    field: 'meterSerialNumber',
    sortable: false,
    width: 100,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.METER_SERIAL_NUMBER,
    cmp: CustomizableColumnComponent,
    options: {
      columnType: CustomizableColumnType.LINK,
      columnValues: (tableItem): CustomizableTableColumnValue[] =>
        (tableItem as unknown as FieldOperationsListItem).meterSerialNumber.map(meter => ({
          text: meter.serialNumber ?? '',
          routerLink: ['/devices/metering', meter.deviceUID ?? '']
        }))
    }
  },
  {
    field: 'meterModel',
    sortable: false,
    width: 250,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.METER_MODEL,
    cmp: MultiLineHighlightComponent
  },
  {
    field: 'port',
    sortable: false,
    width: 100,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.PORT,
    cmp: MultiLineHighlightComponent
  },
  {
    field: 'serviceLocationIds',
    sortable: false,
    width: 150,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.SERVICE_LOCATION_NUMBER,
    cmp: MultiLineHighlightComponent
  },
  {
    field: 'wakeupDateTime',
    sortable: false,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.WAKE_UP_RECEIVED,
    cmp: CheckmarkColumnComponent
  },
  {
    field: 'initialReadDateTime',
    sortable: false,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.READING_RECEIVED,
    cmp: CheckmarkColumnComponent
  },
  {
    field: 'installedBy',
    sortable: true,
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.INSTALLED_BY
  }
];
